import React, { ReactNode } from 'react';
import { ButtonSize, ButtonVariant } from '../../types/button.enum';

interface ButtonProps {
  children: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
  size?: ButtonSize;
  disabled?: boolean;
  fullWidth?: boolean;
  onClick?: () => void;
  classes?: string;
}

const Button: React.FC<ButtonProps> = ({
  children,
  type = 'button',
  variant = ButtonVariant.PRIMARY,
  size = ButtonSize.MEDIUM,
  disabled = false,
  fullWidth = false,
  onClick,
  classes = '',
}) => {

  const setButtonStyle = () => {
    if(ButtonVariant.PRIMARY) {
      return 'bg-[#333] text-white';
    }
    else if (ButtonVariant.SECONDARY) {
      return 'bg-[#e0e0e0] text-[#333]';
    }
    else {
      return 'bg-[#e0e0e0] text-[#333]';
    }
  }

  return (
    <button
      type={type}
      className={
        `sm:h-[45px] sm:min-w-[200px] px-4 font-medium
        inline-flex justify-center items-center rounded-3xl sm:text-[16px]
        ${disabled ? 'cursor-default opacity-35' : 'cursor-pointer'} ${setButtonStyle()} ${classes}`
      }
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;